import { render, staticRenderFns } from "./business.vue?vue&type=template&id=cb53289a&scoped=true"
import script from "./business.vue?vue&type=script&lang=js"
export * from "./business.vue?vue&type=script&lang=js"
import style0 from "./business.vue?vue&type=style&index=0&id=cb53289a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb53289a",
  null
  
)

export default component.exports